import React from 'react';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

/**
 * Öffentliche Route für den Gratis-Tier: erlaubt sowohl Gäste (ohne Login) als
 * auch eingeloggte Nutzer. Wartet nur die Auth-Initialisierung ab, erzwingt aber
 * KEINE Anmeldung (anders als PrivateRoute). Genutzt für Quick Starts und die
 * „Umsonst"-Workouts.
 */
export default function GuestRoute({ children }) {
  const { loading } = useAuth();
  if (loading) return <LoadingSpinner />;
  return children;
}
